import React, { useEffect } from 'react'

import { HeaderStyle } from 'src/components/layout/Header/HeaderStyle'
import LPHeader from 'src/components/layout/Header/LPHeader'
import StepsHeader from 'src/components/layout/Header/StepHeader'
import ButtonCustom from 'src/components/form/Button'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PATH as PATH_MY_PAGE } from 'src/pages/myPage'
import DescriptionHint from 'src/components/layout/Content/DescriptionHint'
import { useAppDispatch, useAppSelector } from 'src/store'
import LodashGet from 'lodash/get'
import { getDetailUserTreatment } from 'src/useCase/userTreatment'
import { getFirstDoctor } from 'src/useCase/doctor'
import LocalStorage from 'src/utils/LocalStorage'
import detailUserTreatment from 'src/store/domain/myPage/detailUserTreatment'

const SuggestSubscriptionContainer: React.FC = (props: any) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [queryParams] = useSearchParams()

  const next = () => {
    navigate(PATH_MY_PAGE.OTHER_MENU)
  }

  const menuName = LocalStorage.getMenuName()

  const userTreatment = useAppSelector(
    (state) => state.domain.myPage.detailUserTreatment.entity,
  )

  useEffect(() => {
    const id =
      LocalStorage.getUserTreatmentId() ?? queryParams.get('userTreatmentId')

    // [SCOPE] No.201: the prescription-NG redirect (checkExistsUserTreatment
    // rejecting at /exists) has no treatment id — the endpoint doesn't return
    // one — so `id` is undefined here. Previously this still called
    // getDetailUserTreatment(undefined), which failed silently and could
    // leave a stale userTreatment from a previously-viewed treatment in the
    // shared `detailUserTreatment` slice. Skip the fetch and clear any stale
    // entity so the doctor-name fallback below uses `firstDoctor` instead.
    if (!id) {
      dispatch(detailUserTreatment.updateEntity(null as any))
      dispatch(getFirstDoctor())
      return
    }

    const params = {
      with: 'lastDoctorFeedback.doctor,menu.doctors,reservation.doctor',
    }
    dispatch(getDetailUserTreatment({ id, params }))
  }, [])

  const attendingDoctorName =
    LodashGet(userTreatment, 'last_doctor_feedback.doctor.name') ||
    LodashGet(userTreatment, 'reservation.doctor.name') ||
    LodashGet(userTreatment, 'menu.doctors.0.name')

  const isAgeNg = LodashGet(userTreatment, 'feedback_type') === 'age_ng'

  const ageNgListText = [
    '問診へのご回答ありがとうございます。',
    '恐れ入りますが、BIOPORT+では、オンライン診療における安全基準に基づき、「18歳未満」および「70歳以上」のお客様への処方は一律でお断りさせていただいております。',
    '<br />',
    '健康状態の急激な変化や、他のお薬との飲み合わせによるリスクを防止するための措置でございます。',
    '何卒ご理解いただけますようお願い致します。',
    '<br />',
    '【本人確認について】',
    'BIOPORT+では、厚生労働省のガイドラインに従い、最終処方前に公的な本人確認書類（免許証・マイナンバーカード等）の照合を必須としております。',
    '<br />',
    '万が一、年齢を偽って受診を継続された場合でも、書類照合の段階で処方はキャンセルとなり、お薬の配送は致しかねます。',
    '患者様の安全を守るための厳格なシステム運用へのご理解をお願い申し上げます。',
  ]

  const defaultListText = [
    `${attendingDoctorName ?? 'ご担当の医師'}です。`,
    '<br />',
    ' 問診のご協力ありがとうございました。 ',
    `大変申し訳ありませんが、診察の結果「診療科目：${menuName}」におけるプランについてはお薬の処方ができません。`,
    'マイページより別の診療科目のプランをご検討ください。',
    '本件につきまして、ご質問やご要望がございましたら、以下のアドレス宛にご連絡ください。',
    'bioportplus@sheepmedical.com',
  ]

  return (
    <>
      <LPHeader />
      <div className="w-full justify-center mx-auto layout-webview-step register-form">
        <StepsHeader
          step={10}
          // stepActive={3}
          stepActiveName={'処方のご提案'}
          className="top-70"
        />
        <HeaderStyle>問診回答の結果、お薬の処方ができません。</HeaderStyle>

        <DescriptionHint listText={isAgeNg ? ageNgListText : defaultListText} />
        <ButtonCustom
          className="btn-default btn-gurkha mt-5"
          loading={false}
          onClick={next}
          htmlType="submit"
          name="マイページ"
          showIconRight
        />
      </div>
    </>
  )
}

export default SuggestSubscriptionContainer
